import React from 'react';

const ImagesGrid = () => {
    return (
        <div className="my-24">
            <div className="text-center pb-4">
                <div className="w-24 h-6 bg-purple-300 rounded-md mx-auto mb-4 relative overflow-hidden">
                    <div
                        className="absolute inset-0 bg-gradient-to-r from-purple-300 via-purple-100 to-purple-300"
                        style={{
                            backgroundSize: '200% 100%',
                            animation: 'shimmer 1.5s infinite linear',
                        }}
                    ></div>
                </div>
                <div className="w-64 h-12 bg-gray-300 rounded-md mx-auto mb-6 relative overflow-hidden">
                    <div
                        className="absolute inset-0 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
                        style={{
                            backgroundSize: '200% 100%',
                            animation: 'shimmer 1.5s infinite linear',
                        }}
                    ></div>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-6 gap-4 px-4 md:px-20 mb-10">
                {[...Array(18)].map((_, index) => (
                    <div
                        key={index}
                        className="bg-gray-300 rounded-md h-44 relative overflow-hidden"
                    >
                        <div
                            className="absolute inset-0 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
                            style={{
                                backgroundSize: '200% 100%',
                                animation: 'shimmer 1.5s infinite linear',
                            }}
                        ></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImagesGrid;
